<template>
  <div id="page-top">
    <div id="wrapper">
      <Navbar></Navbar>
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          <Topbar></Topbar>
          <div class="container-fluid">
            <transition name="fade">
              <div id="preloader">
                <div data-loader="circle-side"></div>
              </div>
            </transition>
            <transition name="fade">
              <div id="loader_form">
                <div data-loader="circle-side-2"></div>
              </div>
            </transition>
            <div class="card shadow mb-4">
              <div class="card-header py-3 d-flex align-items-center justify-content-between">
                <h6 class="m-0 font-weight-bold text-dark">Evaluateurs</h6>
                <button class="btn btn-sm btn-success shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#addModalAssessor" v-bind:disabled="addAssessorProcess || editAssessorProcess || deleteAssessorProcess"><i class="fas fa-plus fa-md"></i></button>
              </div>
              <div class="card-body">
                <transition name="fade">
                  <div v-if="messageAlert" class="alert p-3" v-bind:class="{ 'alert-success': isSuccess, 'alert-danger': isError }" role="alert">
                    {{messageAlert}}
                  </div>
                </transition>
                <div class="table-responsive">
                  <table class="table table-hover table-bordered" id="dataTableAssessor" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Nom</th>
                        <th>Type</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <th>#</th>
                        <th class="d-none">Id</th>
                        <th>Nom</th>
                        <th>Type</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </tfoot>
                    <tbody>
                      <tr v-for="(item, index) in assessors" v-bind:key="item.id">
                        <td>{{index+1}}</td>
                        <td class="d-none">{{item.id}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.type}}</td>
                        <td class="text-center">
                          <button class="btn btn-sm btn-primary shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#viewModalAssessor" v-on:click="viewAssessor(item.id)" v-bind:disabled="addAssessorProcess || editAssessorProcess || deleteAssessorProcess">
                          <i class="fas fa-eye fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-warning shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#editModalAssessor" v-on:click="viewAssessor(item.id)" v-bind:disabled="addAssessorProcess || editAssessorProcess || deleteAssessorProcess">
                          <i class="fas fa-pencil-alt fa-md"></i>
                          </button>
                          <button class="btn btn-sm btn-danger shadow-sm" href="javascript:void(0)" data-toggle="modal" data-target="#deleteModalAssessor" v-on:click="viewAssessor(item.id)" v-bind:disabled="addAssessorProcess || editAssessorProcess || deleteAssessorProcess">
                          <i class="fas fa-trash fa-md"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
    </a>
    <!-- Add Modal Evaluateur -->
    <div class="modal fade" id="addModalAssessor" tabindex="-1" role="dialog" aria-labelledby="ModalAssessorLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="addAssessorForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalAssessorLabel">Ajouter Evaluateur</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-6">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name1" name="name1" required>
                </div>
                <div class="col-sm-6">
                  <label>Email</label>
                  <input type="text" class="form-control mb-2" v-model="email1" name="email1" required>
                </div>
                <div class="col-sm-6">
                  <label>Téléphone</label>
                  <input type="text" class="form-control mb-2" v-model="phone1" name="phone1" required>
                </div>
                <div class="col-sm-6">
                  <label>Type</label>
                  <select class="form-control mb-2" v-model="type1" name="type1">
                    <option value="Évaluateur Interne">Évaluateur Interne</option>
                    <option value="Auditeur Interne">Auditeur Interne</option>
                    <option value="Auditeur Externe">Auditeur Externe</option>
                  </select>                
                </div>
                <div class="col-sm-12">
                  <label>Entreprise</label>
                  <input type="text" class="form-control" v-model="company1" name="company1" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-success text-uppercase w-50" href="javascript:(0)" v-on:click="addAssessor" v-bind:disabled="addAssessorProcess || editAssessorProcess || deleteAssessorProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="addAssessorProcess">
              Ajouter
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- View Modal Evaluateur -->
    <div class="modal fade" id="viewModalAssessor" tabindex="-1" role="dialog" aria-labelledby="ModalAssessorLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalAssessorLabel">Evaluateur [#<span>{{indexAssessor+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row">Id</th>
                  <td>{{id2}}</td>
                </tr>
                <tr>
                  <th scope="row">Nom</th>
                  <td>{{name2}}</td>
                </tr>
                <tr>
                  <th scope="row">Type</th>
                  <td>{{type2}}</td>
                </tr>
                <tr>
                  <th scope="row">Email</th>
                  <td>{{email2}}</td>
                </tr>
                <tr>
                  <th scope="row">Phone</th>
                  <td>{{phone2}}</td>
                </tr>
                <tr>
                  <th scope="row">Entreprise</th>
                  <td>{{company2}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary text-uppercase w-50" href="javascript:(0)" data-dismiss="modal">
            Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Modal Evaluateur -->
    <div class="modal fade" id="editModalAssessor" tabindex="-1" role="dialog" aria-labelledby="ModalAssessorLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form id="editAssessorForm" class="user" action="javascript:void(0);">
            <div class="modal-header">
              <h5 class="modal-title" id="ModalAssessorLabel">Modifier Evaluateur [#<span>{{indexAssessor+1}}</span>]</h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-row">
                <div class="col-sm-6">
                  <label>Nom</label>
                  <input type="text" class="form-control mb-2" v-model="name3" name="name3" required>
                </div>
                <div class="col-sm-6">
                  <label>Email</label>
                  <input type="text" class="form-control mb-2" v-model="email3" name="email3" required>
                </div>
                <div class="col-sm-6">
                  <label>Téléphone</label>
                  <input type="text" class="form-control mb-2" v-model="phone3" name="phone3" required>
                </div>
                <div class="col-sm-6">
                  <label>Type</label>
                  <select class="form-control mb-2" v-model="type3" name="type3">
                    <option value="Évaluateur Interne">Évaluateur Interne</option>
                    <option value="Auditeur Interne">Auditeur Interne</option>
                    <option value="Auditeur Externe">Auditeur Externe</option>
                  </select>                
                </div>
                <div class="col-sm-12">
                  <label>Entreprise</label>
                  <input type="text" class="form-control" v-model="company3" name="company3" required>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-warning text-uppercase w-50" href="javascript:(0)" v-on:click="editAssessor" v-bind:disabled="addAssessorProcess || editAssessorProcess || deleteAssessorProcess">
              <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="editAssessorProcess">
              Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Delete Modal Evaluateur -->
    <div class="modal fade" id="deleteModalAssessor" tabindex="-1" role="dialog" aria-labelledby="ModalAssessorLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalAssessorLabel">Supprimer Evaluateur [#<span>{{indexAssessor+1}}</span>]</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center text-uppercase mt-3">êtes-vous sûr de vouloir supprimer cet evaluateur ?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger text-uppercase w-50" href="javascript:(0)" v-on:click="deleteAssessor" v-bind:disabled="addAssessorProcess || editAssessorProcess || deleteAssessorProcess">
            <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="deleteAssessorProcess">
            Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 999999;
}
[data-loader="circle-side"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
#loader_form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 999999;
  display: none;
}
[data-loader="circle-side-2"] {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  -webkit-animation: circle infinite .95s linear;
  -moz-animation: circle infinite .95s linear;
  -o-animation: circle infinite .95s linear;
  animation: circle infinite .95s linear;
  border: 2px solid #333;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;
}
@-webkit-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes circle {
  0% {
    -webkit-transform: rotate(0);
    -ms-transform: rotate(0);
    -o-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>

<script>
import Navbar from './Navbar'
import Topbar from './Topbar'
import Footer from './Footer'
import axios from 'axios'
$.fn.isValid = function () {
  return this[0].checkValidity()
}
export default {
  name: 'App',
  components: {
    'Topbar': Topbar,
    'Navbar': Navbar,
    'Footer': Footer
  },
  data () {
    return {
      loading: true,
      progress: 0,
      assessor: {},
      indexAssessor: '',
      assessors: [],
      isSuccess: true,
      isError: false,
      messageAlert: '',
      addAssessorProcess: false,
      viewAssessorProcess: false,
      editAssessorProcess: false,
      deleteAssessorProcess: false,
      name1: '',
      type1: '',
      email1: '',
      phone1: '',
      company1: '',
      id2: '',
      name2: '',
      type2: '',
      email2: '',
      phone2: '',
      company2: '',
      name3: '',
      type3: '',
      email3: '',
      phone3: '',
      company3: '',
      dTableAssessor: ''
    }
  },
  methods: {
    init () {
      setTimeout(() => {
        this.dTableAssessor = $('#dataTableAssessor').DataTable({
          'columns': [
            { 'width': '15' },
            null,
            null,
            null,
            { 'width': '100' }
          ],
          'lengthMenu': [
            [10],
            [10]
          ],
          order: [
            [0, 'desc']
          ],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true
        })
        this.assessor = {
          'id': '',
          'code': '',
          'name': ''
        }
        this.name1 = ''
        this.type1 = ''
        this.email1 = ''
        this.phone1 = ''
        this.company1 = ''
        this.id2 = ''
        this.name2 = ''
        this.type2 = ''
        this.email2 = ''
        this.phone2 = ''
        this.company2 = ''
        this.name3 = ''
        this.type3 = ''
        this.email3 = ''
        this.phone3 = ''
        this.company3 = ''
      }, 50)
    },
    getAssessors () {
      axios.get(this.apiUrl+'/assessors', {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          this.assessors = res.data
          this.progress += 1
          if (this.progress === 1) this.loading = false
        }).catch(err => {
          console.log(err)
        })
    },
    addAssessor () {
      if ($('#addAssessorForm').isValid()) {
        this.addAssessorProcess = true
        let assessor = {
          'id': this.assessors.length + 1,
          "name": this.name1,
          "company": this.company1,
          "email": this.email1,
          "phone": this.phone1,
          "type": this.type1
        }
        axios.post(this.apiUrl+'/assessors', assessor, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 201) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement ajouté avec succès'
            this.assessors.push(assessor)
            this.dTableAssessor.destroy()
            this.init()
          }
          $('#addModalAssessor').modal('hide')
          this.addAssessorProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#addModalAssessor').modal('hide')
          this.addAssessorProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    viewAssessor (id) {
      this.assessor = this.assessors.filter(function (item) {
        return item.id === id
      })[0]
      this.indexAssessor = this.assessors.indexOf(this.assessor)
      this.id2 = this.assessor.id
      this.name2 = this.assessor.name
      this.type2 = this.assessor.type
      this.email2 = this.assessor.email
      this.phone2 = this.assessor.phone
      this.company2 = this.assessor.company
      this.name3 = this.assessor.name
      this.type3 = this.assessor.type
      this.email3 = this.assessor.email
      this.phone3 = this.assessor.phone
      this.company3 = this.assessor.company
    },
    editAssessor () {
      if ($('#editAssessorForm').isValid()) {
        var id = this.assessor.id
        this.editAssessorProcess = true
        axios.put(this.apiUrl+'/assessors/' + id, {
          "name": this.name3,
          "company": this.company3,
          "email": this.email3,
          "phone": this.phone3,
          "type": this.type3
        }, {headers: {'Authorization': `Bearer ${this.token}`}}).then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement modifié avec succès'
            this.assessor.name = this.name3
            this.assessor.company = this.company3
            this.assessor.email = this.email3
            this.assessor.phone = this.phone3
            this.assessor.type = this.type3
            this.assessors[this.indexAssessor] = this.assessor
            this.dTableAssessor.destroy()
            this.init()
          }
          $('#editModalAssessor').modal('hide')
          this.editAssessorProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#editModalAssessor').modal('hide')
          this.editAssessorProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
      }
    },
    deleteAssessor () {
      var id = this.assessor.id
      this.deleteAssessorProcess = true
      axios.delete(this.apiUrl+'/assessors/' + id, {headers: {'Authorization': `Bearer ${this.token}`}})
        .then(res => {
          if (res.status == 200) {
            this.isSuccess = true
            this.isError = false
            this.messageAlert = 'enregistrement supprimé avec succès'
            this.assessors.splice(this.indexAssessor, 1)
            this.dTableAssessor.destroy()
            this.init()
          }
          $('#deleteModalAssessor').modal('hide')
          this.deleteAssessorProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        }).catch(err => {
          console.log(err)
          this.isError = true
          this.isSuccess = false
          this.messageAlert = err
          $('#deleteModalAssessor').modal('hide')
          this.deleteAssessorProcess = false
          setTimeout(function () {
            this.messageAlert = ''
          }.bind(this), 3500)
        })
    }
  },
  created () {
    $('body').css({'overflow': 'hidden'})
    this.getAssessors()
  },
  watch: {
    loading: function () {
      this.init()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      $('[data-loader="circle-side"]').fadeOut()
      $('#preloader').delay(350).fadeOut('slow')
      $('body').delay(350).css({
        'overflow': 'auto'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Assessor.vue